var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center gap-1 px-3 py-2 text-md border rounded",class:`${_vm.bgColor} ${_vm.textColor}`,on:{"click":function($event){$event.stopPropagation();return _vm.$emit('onClick')}}},[_vm._t("icon"),_vm._v("\n    "+_vm._s(_vm.text)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }